import { useParams } from 'react-router-dom';
import { Container } from '@occc-app/design-system';
import { AwardDetailsPage } from '@occc-app/routes/AwardCatalog/AwardDetailsPage/AwardDetailsPage';
import { usePreparedOfferHook } from '@occc-app/routes/CampaignComponents/component-details/use-prepared-offer.hook';
import { getAwardDetailsPageHeaderLinks } from './utils';

const AwardDetailsPageContainer = () => {
  const { id: offerId = '' } = useParams<{ id: string }>();
  const { loading, error, offer, constraintSupplementalData } = usePreparedOfferHook(offerId);

  const getAwardNameToDisplayInBreadcrumb = () => {
    if (error) {
      return 'Something went wrong';
    }

    if (loading && !offer) {
      return 'Loading...';
    }

    if (!offer) {
      return 'Page Not Found';
    }

    return offer.name;
  };

  const links = getAwardDetailsPageHeaderLinks(getAwardNameToDisplayInBreadcrumb(), offerId);

  return (
    <Container>
      <AwardDetailsPage
        offer={offer}
        constraintSupplementalData={constraintSupplementalData}
        loading={loading}
        error={error}
        links={links}
      />
    </Container>
  );
};

export default AwardDetailsPageContainer;
